import { API_BASE } from '../../../api';

export const ENDPOINTS = {
    personasDirecciones: (id) => `${API_BASE}/Direcciones?IdPersona=${id}`,
    personasTelefonos: (id) => `${API_BASE}/Telefonos?IdPersona=${id}`,
    personasEmails: (id) => `${API_BASE}/Emails?IdPersona=${id}`,
    personasIdentifs: (id) => `${API_BASE}/Identificaciones?IdPersona=${id}`,
    personasOcupaciones: (id) => `${API_BASE}/Ocupaciones?IdPersona=${id}`,
    personasObservs: (id) => `${API_BASE}/Observaciones?IdPersona=${id}`,

    direcciones: `${API_BASE}/Direcciones`,
    direccionById: (id) => `${API_BASE}/Direcciones/${id}`,

    direccionesUnidadesOrg: `${API_BASE}/DireccionesUnidadesOrg`,
    direccionUnidadOrgById: (id) => `${API_BASE}/DireccionesUnidadesOrg/${id}`,

    personas: `${API_BASE}/Personas`,
    personaById: (id) => `${API_BASE}/Personas/${id}`,

    usuarios: `${API_BASE}/Usuarios`,
    usuarioById: (id) => `${API_BASE}/Usuarios/${id}`,

    personaRedSocial: `${API_BASE}/PersonaRedSocial`,
    personaRedSocialById: (id) => `${API_BASE}/PersonaRedSocial/${id}`,

    nivelesJerarquicos: `${API_BASE}/NivelesJerarquicos`,
    nivelesJerarquicosById: (id) => `${API_BASE}/NivelesJerarquicos/${id}`,

    aprobacionesReservas: `${API_BASE}/AprobacionesReservas`,
    aprobacionesReservasById: (id) => `${API_BASE}/AprobacionesReservas/${id}`,

    tipoUnidadOrg: `${API_BASE}/TipoUnidadOrganizacional`,
    tipoUnidadOrgById: (id) => `${API_BASE}/TipoUnidadOrganizacional/${id}`,

    unidadesOrg: `${API_BASE}/UnidadesOrganizacionales`,
    unidadesOrgById: (id) => `${API_BASE}/UnidadesOrganizacionales/${id}`,

    zonasGeograficas: `${API_BASE}/ZonasGeograficas`,
    zonasGeograficasById: (id) => `${API_BASE}/ZonasGeograficas/${id}`,

    colores: `${API_BASE}/Colores`,
    coloresDefault: `${API_BASE}/Colores/default`,
    coloresById: (id) => `${API_BASE}/Colores/${id}`,

    logos: `${API_BASE}/Logos`,
    logosDefault: `${API_BASE}/Logos/default`,
    logosById: (id) => `${API_BASE}/Logos/${id}`,

    imagenesSistema: `${API_BASE}/ImagenesSistema`,
    imagenesSistemaDefault: `${API_BASE}/ImagenesSistema/default`,
    imagenesSistemaById: (id) => `${API_BASE}/ImagenesSistema/${id}`,

    configuracionesSistema: `${API_BASE}/Configuraciones`,

    telefonos: `${API_BASE}/Telefonos`,
    telefonoById: (id) => `${API_BASE}/Telefonos/${id}`,

    emails: `${API_BASE}/Emails`,
    emailById: (id) => `${API_BASE}/Emails/${id}`,

    identificaciones: `${API_BASE}/Identificaciones`,
    identifById: (id) => `${API_BASE}/Identificaciones/${id}`,

    observaciones: `${API_BASE}/Observaciones`,
    observacionById: (id) => `${API_BASE}/Observaciones/${id}`,

    ocupaciones: `${API_BASE}/Ocupaciones`,
    ocupacionById: (id) => `${API_BASE}/Ocupaciones/${id}`,

    empresas: `${API_BASE}/Empresas`,
    empresasById: (id) => `${API_BASE}/Empresas/${id}`,
    empresasUsuario: (id) => `${API_BASE}/Empresas/usuario/${id}`,

    empresasUnidadesOrg: `${API_BASE}/EmpresasUnidadesOrg`,
    empresasUnidadesOrgById: (id) => `${API_BASE}/EmpresasUnidadesOrg/${id}`,

    areasNegocios: `${API_BASE}/AreasNegocio`,
    areasNegociosById: (id) => `${API_BASE}/AreasNegocio/${id}`,

    empleados: `${API_BASE}/Empleados`,
    empleadosById: (id) => `${API_BASE}/Empleados/${id}`,

    puestos: `${API_BASE}/Puestos`,
    puestosById: (id) => `${API_BASE}/Puestos/${id}`,

    turnos: `${API_BASE}/Turnos`,
    turnosById: (id) => `${API_BASE}/Turnos/${id}`,

    redSocial: `${API_BASE}/RedSocial`,
    redSocialById: (id) => `${API_BASE}/RedSocial/${id}`,

    unidadesOrgEmpleado: `${API_BASE}/UnidadesOrgEmpleado`,
    unidadesOrgEmpleadoById: (id) => `${API_BASE}/UnidadesOrgEmpleado/${id}`,

    proyectos: `${API_BASE}/Proyectos`,
    proyectosById: (id) => `${API_BASE}/Proyectos/${id}`,

    configuraciones: `${API_BASE}/Configuraciones`,
    configuracionById: (id) => `${API_BASE}/Configuraciones/${id}`,

    avisosPrivacidad: `${API_BASE}/AvisosPrivacidad`,
    avisosPrivacidadById: (id) => `${API_BASE}/AvisosPrivacidad/${id}`,
    avisosPrivacidadPendientes: (idUsuario) => `${API_BASE}/AvisosPrivacidad/pendientes/${idUsuario}`,
    avisosPrivacidadAceptar: `${API_BASE}/AvisosPrivacidad/aceptar`,
}